(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('IntegrationController', IntegrationController);

    IntegrationController.$inject = ['Integration', 'IntegrationScope', 'TabDomains', '$state', '$uibModal'];

    function IntegrationController (Integration, IntegrationScope, TabDomains, $state, $uibModal) {
        var vm = this;

        vm.client = {};
        vm.selectedDomain = {};
        vm.selectedScopes = [];
        vm.domains = TabDomains.query({size:1000});
        vm.scopes = IntegrationScope.query();

        vm.generated = false;
        vm.disabled = true;
        vm.checkRequireFields = true;

        vm.generateClient = function () {
            var body = {
                scope: evaluateScope(),
                domain: vm.selectedDomain
            };

            Integration.save(body, onSuccessSave, onErrorSave);
        }

        function evaluateScope() {
            vm.selectedScopes.sort(function (a, b) {
                var scope1 = a.id, scope2 = b.id;
                return scope1-scope2;
            });

            var scope = "";
            angular.forEach(vm.selectedScopes, function(s){
                scope += s.scope + ",";
            });
            return scope.substring(0, scope.length -1);
        }

        function onSuccessSave(data) {
            vm.generated = true;
            vm.disabled = false;
            vm.client.id = data.clientId;
            vm.client.secret = data.clientSecret;
            showValues();
        }

        function onErrorSave() {}

        vm.clear = function() {
            $state.reload();
        }

        vm.refreshRequired = function() {
            vm.checkRequireFields = !(vm.selectedDomain !== {} && vm.selectedDomain !== null)
                || !(vm.selectedScopes !== [] && vm.selectedScopes !== null && vm.selectedScopes.length > 0);
        }

        function showValues() {
            $uibModal.open({
                templateUrl: 'app/account/settings/integration/show-integration.html',
                controller: 'ShowIntegrationController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: vm.client
                }
            });
        }
    }
})();
